import { UserProfile } from '@dao';

interface AdminGuardProps {
  children: React.ReactNode;
  profile?: UserProfile;
}

/**
 * This guard ONLY checks whether the user is an admin or not. If the user is an
 * admin, or if there is no user, the children components will be rendered. For
 * this reason, it should be used in conjunction with the AuthGuard.
 */
export function AdminGuard({ children, profile }: AdminGuardProps) {
  // Block non-admin users.
  if (profile && !profile.isAdmin) {
    return <div>Restricted access</div>;
  }

  return <>{children}</>;
}
